export const OVER_LIMIT_ERROR_MESSAGE =
  "Sorry, you can't add more than 20 Emails";
export const INVALID_EMAIL = 'Invalid Email';
export const ALLOWED_EMAIL_COUNT = 20;
export const CHIP_CLOSE_ICON = 'chipClose';
export const EMPTY_EMAIL_INPUT_ERROR = 'Email Input cannot be empty';
